export class CreateLicenceRequestDto {
    licenceRequestCode: string = '';
    distributor: string = '';
    country: string = '';
    libraryName: string = '';
    deviceUse: string = '';
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/dtos/licencing/create-licence-request.dto.ts